import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Button, Typography, Container} from '@material-ui/core';
import { useHistory, useLocation } from "react-router-dom";
import { Staging } from './Staging/StagingPage';
import Search from './Search/SearchPage';
import Folders from './Folders/FolderPage';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import GridViewIcon from '@material-ui/icons/GridOn';
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import UploadModal from "./UploadModal";
import { hasPrivilege } from "../../utils/privileges_utility";



const tabMapping = {
    staging: 0,
    search: 1,
    folders: 2
  };
  
const reverseTabMapping = Object.keys(tabMapping).reduce(
    (obj, key) => ({ ...obj, [tabMapping[key]]: key }),
    {}
);

const useStyles = makeStyles(theme => ({
  transparentIcon: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    borderRadius: '8px',
    cursor: 'pointer',
  },

  whiteIcon:{
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    cursor: 'pointer',
  },

  iconContainer:{
    display:"flex",
    backgroundColor:"#f5f3f6",
    borderRadius:"12px",
    marginLeft:2,
    p:0.5
  },

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 2,
    mb: 2 
  },

  actionButton:{
    backgroundColor: '#00445D',
    borderRadius: '18px',
    textTransform: 'none',
    color: '#fff', // text color
    '&:hover': {
      backgroundColor: '#0d1b5e',
    },
    width:'91px',
    height: '36px',
    fontSize: '12px' 
  },

  pillButton: {
    borderRadius: '18px',  
    padding: theme.spacing(1.5, 4),
    textTransform: 'none',
    borderColor: '#0E4B5B',  
    color: '#0E4B5B',
    fontWeight: 600,
    '&:hover': {
      borderColor: '#0E4B5B',
      backgroundColor: 'rgba(14,75,91,0.08)',
    },
    width:'91px',
    height: '36px',
    fontSize: '12px' 
  },

  title:{
    fontFamily: 'PilatWideHeavy', 
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '32px'
  },

  controlContainer:{
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },

  tabHeader:{
    '& .MuiTabs-indicator': {
      backgroundColor: '#000', 
      height: '2px'
    }
  },

  tabColumn:{
    minWidth: 'auto',
    paddingX: 1,
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '400',
    color: '#757575'
  },

  highlightedTabColumn:{
    minWidth: 'auto',
    paddingX: 1,
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '700',
    color: '#000'
  },

  recycleBin: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
    color: "#0E4B5B",
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#083446",
    },
    marginRight: '30px'
  },
  icon: {
    fontSize: 20,
    marginRight: 4,
  },
  label: {
    fontSize: '14px',
  },

  controlBox: {
    display: "flex",
    alignItems: "center"
  }
}));


const MainPage = ({currentCompany}) => {
    const classes = useStyles();
    const [selectedTab, setSelectedTab] = useState(0);
    const history = useHistory();
    const location = useLocation();
    const [viewMode, setViewMode] = useState('list');
    const [open, setOpen] = useState(false);
    const [files, setFiles] = useState([]);

    const canUpload = hasPrivilege("DS_FILE_UPLOAD");



    const handleFileChange = (e) => {
      const selectedFiles = Array.from(e.target.files);

      if (selectedFiles.length) {
        setFiles(selectedFiles);
        setOpen(true);
      }

      e.target.value = "";
    };

    const handleClose = () => {
      setFiles([]);
      setOpen(false);
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tab = queryParams.get('tab');
        if (tab && tabMapping[tab] !== undefined) {
          setSelectedTab(tabMapping[tab]);
        }
    }, [location.search]);

    const handleNavigation = tab => {
        const tabName = reverseTabMapping[tab];
        history.push(`/document-suite?tab=${tabName}`);
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        handleNavigation(newValue);
    };

    const handleRecycleBinOpen = () => {
      history.push('/document-suite/documents/recyclebin');
    }

    return (
      <Container maxWidth="xl" style={{ padding: '20px' }}>
          <div style={{marginBottom: '20px'}}>
            <Box className={classes.titleContainer}>
                  <Typography 
                  variant="h4" 
                  className={classes.title}
                  >
                  DOCUMENTS
                  </Typography>

                  {/* <div className={classes.controlContainer}>
                      <Button  variant="contained" className={classes.actionButton} onClick={handleOpen}>
                          Import
                      </Button>
                      <Button  variant="contained" className={classes.actionButton}>
                          Scan
                      </Button>
                  </div> */}

                {canUpload ? <div className={classes.controlContainer}>
                      <div>
                        <input
                          id="upload-input"
                          type="file"
                          hidden
                          multiple
                          onChange={handleFileChange}
                        />
                        <label htmlFor="upload-input">
                          <Button
                            variant="outlined"
                            startIcon={<CloudUploadOutlinedIcon />}
                            className={classes.pillButton}
                            component="span"  // makes the button act like a <label>
                          >
                            Upload
                          </Button>
                        </label>
                      </div>

                      <Button
                        variant="outlined"
                        startIcon={<PrintOutlinedIcon />}
                        className={classes.pillButton}
                      >
                        Scan
                      </Button>
                  </div> : null }

            </Box>
          </div>
          <Box display="flex" justifyContent="space-between" alignItems="center">
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="primary"
            className={classes.tabHeader}
          >
            <Tab className={selectedTab===0 ? classes.highlightedTabColumn : classes.tabColumn} label="Staging" />
            <Tab className={selectedTab===1 ? classes.highlightedTabColumn : classes.tabColumn} label="Search" />
            <Tab className={selectedTab===2 ? classes.highlightedTabColumn : classes.tabColumn} label="Folders" />
          </Tabs>
          <Box className={classes.controlBox}>
              <Box className={classes.recycleBin} onClick={handleRecycleBinOpen}>
                <DeleteOutlineIcon className={classes.icon} />
                <Typography className={classes.label}><b>Recycle Bin</b></Typography>
              </Box>

              <Box className={classes.iconContainer}>
                {/* List View Icon */}
                <Box
                  onClick={() => setViewMode('list')}
                  className={viewMode === 'list' ? classes.whiteIcon : classes.transparentIcon}
                >
                  <FormatListBulletedIcon sx={{ color: '#0B3D56', fontSize: 24 }} />
                </Box>

                {/* Grid View Icon */}
                <Box 
                  onClick={() => setViewMode('grid')}
                  className={viewMode === 'grid' ? classes.whiteIcon : classes.transparentIcon}
                >
                  <GridViewIcon sx={{ color: '#0B3D56', fontSize: 24 }} />
                </Box>
            </Box>


          </Box>
         
          </Box>
    
          {selectedTab === 0 && (
            <Staging viewType={viewMode} currentCompany={currentCompany} />
          )}

          {selectedTab === 1 && (
            <Search viewType={viewMode} currentCompany={currentCompany} />
          )}

          {selectedTab === 2 && (
            <Folders viewType={viewMode} currentCompany={currentCompany} />
          )}

          <UploadModal
            open={open}
            onClose={handleClose}
            files={files}
            onRemoveFile={(idx) =>
              setFiles((prev) => prev.filter((_, i) => i !== idx))
            }
          />
        </Container>
      );
}

export default MainPage;